import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import Wrapper from "../../components/Wrapper";


export default function Sellers() {

  return (
    <Wrapper>
      <Link
        to={{
          pathname: "/notifs/test",
        }}
      >
        Test Notif
      </Link>
    </Wrapper>
  );
}
